<!-- MODAL reservaCombo -->
<div mdbModal #reservaCombo="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Reserva de Inventario
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="reservaCombo.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form autocomplete="off" [formGroup]="formHeader">
                    <div class="row">
                        <div class="col dato" style="max-width: 250px;">
                            <Strong class="title">Fecha Mov.:</Strong>&nbsp;
                            <span class="value">{{dateTime | date }}</span>
                        </div>
                        <div class="col dato" style="max-width: 300px;">
                            <Strong class="title">Descripción:</Strong>&nbsp;
                            <span class="value">{{descripcion}}</span>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col" style="max-width: 300px;">
                            <div class="md-form m-0">
                                <mdb-select label="Bodega" [options]="optionsBodega" placeholder="Seleccionar Bodega"
                                    [filterEnabled]="true" formControlName="bodega"></mdb-select>
                                <div *ngIf="
                                  formHeader.get('bodega').invalid &&
                                  (formHeader.get('bodega').dirty ||
                                  formHeader.get('bodega').touched)
                                ">
                                    <mdb-error *ngIf="formHeader.get('bodega').hasError('required')">
                                        Ingrese bodega
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col" style="max-width: 200px;">
                            <div class="md-form m-0">
                                <input value="" type="text" class="form-control" placeholder="Cantidad" required
                                    #cantiad formControlName="cantidad" monto />
                                <label for="cantidad">Cantidad</label>
                                <div *ngIf="formHeader.get('cantidad').invalid && (formHeader.get('cantidad').dirty || formHeader.get('cantidad').touched)">
                                    <mdb-error *ngIf="formHeader.get('cantidad').hasError('required')">Ingrese cantidad</mdb-error>
                                    <mdb-error *ngIf="formHeader.get('cantidad').hasError('min')">Cantidad debe ser mayor o igual a 0</mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col dato" style="min-width: 350px; display: flex; align-items: center;">
                            <!-- Material inline 1 -->
                            <div class="form-check form-check-inline" style="margin-right: 20px;">
                                <input type="radio" class="form-check-input" mdbInput id="movimiento_entrada"
                                    [value]="MOVIMIENTO_ENTRADA" formControlName="movimientoEntradaOrSalida" />
                                <label class="form-check-label" for="movimiento_entrada">Entrada</label>
                            </div>
                            <!-- Material inline 2 -->
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" mdbInput id="movimiento_salida"
                                    [value]="MOVIMIENTO_SALIDA" formControlName="movimientoEntradaOrSalida" />
                                <label class="form-check-label" for="movimiento_salida">Salida</label>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">

                    </div>
                </form>
                <div class="table-responsive">
                    <app-no-data-alert *ngIf="listaProductosCombo?.length === 0"></app-no-data-alert>
                    <table class="table table-striped table-hover table-sm align-middle"
                        *ngIf="listaProductosCombo?.length > 0">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col" class="text-center">Código</th>
                                <th scope="col" class="text-center">Descripción</th>
                                <th scope="col" class="text-center">Formato</th>
                                <th>Cantidad</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let combo of listaProductosCombo; trackBy: trackByProductoCombo">
                                <td>{{ combo.sku }}</td>
                                <td>{{ combo.producto_descripcion }}</td>
                                <td>{{ combo.formato_nombre }}</td>
                                <td>{{ combo.cantidad | numerico }}</td>
                                <td>{{ combo.reserva | numerico }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="reservaCombo.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <button type="button" class="btn btn-secondary waves-light" [ngClass]="{disabledContent: !allowSave}"
                    mdbWavesEffect (click)="guardarReserva()">
                    Guardar
                </button>
            </div>
        </div>
    </div>
</div>